const SET_MAP = {
  initMap(apiKey, center, zoom, style, containerId) {
    mapboxgl.accessToken = apiKey;

    return new mapboxgl.Map({
      container: containerId,
      center: center,
      zoom: zoom,
      style: style
    });
  },

  initLocalGeocoder(features) {
    return new MapboxGeocoder({
      accessToken: mapboxgl.accessToken,
      mapboxgl: mapboxgl,
      flyTo: {
        zoom: 12
      },
      placeholder: 'Rechercher une ville, un quartier...',
      marker: false,
      localGeocoder: (query) => customGeocoder(query, features),
      localGeocoderOnly: true
    });
  },

  initApiGeocoder() {
    let lastQuery = null;
    let cachedResults = [];
    let geocoder;

    geocoder = new MapboxGeocoder({
      accessToken: mapboxgl.accessToken,
      mapboxgl: mapboxgl,
      flyTo: false,
      placeholder: 'Rechercher une ville, un quartier...',
      marker: false,
      localGeocoderOnly: true,
      localGeocoder: (query) => {
        if (query === lastQuery) return cachedResults;

        lastQuery = query;
        cachedResults = [];

        fetch(`/api/v1/autocompletes/zones?active_only=true&q[name_or_zip_codes_agg_cont_any]=${encodeURIComponent(query)}`)
          .then(res => res.json())
          .then(data => {
            if (geocoder._inputEl?.value !== query) return;
            // Filter out zones with no coordinates — invalid GeoJSON crashes MapboxGeocoder
            const filtered = data.results.filter(zone => zone.lat != null && zone.lng != null);
            cachedResults = filtered.map((zone, index) => ({
              type: 'Feature',
              place_name: zone.display_name,
              // Descending relevance so MapboxGeocoder preserves API order instead of resorting
              relevance: 1 - index / Math.max(filtered.length, 1),
              geometry: { type: 'Point', coordinates: [zone.lng, zone.lat] },
              properties: zone
            }));
            geocoder._typeahead?.update(cachedResults);
          });

        return [];
      }
    });

    return geocoder;
  },

  initGeocoder(types) {
    return new MapboxGeocoder({
      accessToken: mapboxgl.accessToken,
      mapboxgl: mapboxgl,
      countries: 'fr',
      types: types || 'address'
    })
  }
};

export default SET_MAP;

function customGeocoder(query, features) {
  const matchingFeatures = features.filter(({ properties }) => properties.name.toLowerCase().includes(query.toLowerCase())).filter(({ properties }) => properties.active);

  const options = [];
  for (const feature of matchingFeatures) {
    feature['place_name'] = feature.properties.name;
    options.push(feature);
  }

  const uniqueOptions = options.filter((value, index, self) => index === self.findIndex((f) => f.place_name === value.place_name));
  return uniqueOptions;
}
